import styled from "styled-components";
import { Box } from "theme-ui";
import { themevals as theme } from "theme/themevals";

interface CustomProps {
  $errors?: any;
}

export const inputStyles = {
  height: 36,
  borderRadius: 6,
  paddingLeft: 10,
  paddingRight: 10,
  minHeight: 36,
};

export const InputWrap = styled(Box)<CustomProps>`
  && {margin-bottom: 30px;}
  display: flex;
  flex-direction: column;
  position:relative;
  input{
    max-width: 100%;
    font-family: "Poppins";
    font-size: 14px;
    line-height: 1.4;
    font-weight: 500;
    border: 1px solid ${(props) => props.$errors ? theme.colors.danger + "!important" : theme.colors.mdgrey};
    color: ${theme.colors.body};
    ${inputStyles}
    @media (max-width: 768px) {
      font-size: 16px;
      line-height: 1.5;
      height: 40px;
    }
  }
`;

export const labelStyles = {
  marginBottom: 0,
  display: "flex",
  justifyContent : "space-between",
  alignItems: "flex-end",
  fontSize: 12,
  fontWeight: 500,
  fontFamily:"Poppins"
};

export const LabelWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  width: 100%;
  label {
    color: ${theme.colors.dkgrey};
    ${labelStyles}
     @media (max-width: 768px) {
      font-size: 14px;
    }
  }
  small {
    font-style: italic; font-size: .75rem; color: ${(props) => theme.colors.ltgrey};
  }
`;



export const Error = styled.div` 
  color:${(props) => theme.colors.danger};
  margin-top:10px; 
  font-size:12px;
  font-weight: 600;
  font-family:"Poppins";
  position:absolute;
  bottom:-25px;
`

export const PasswordToggleWrap = styled.div`
  position: relative;
`;

export const VisibleWrap = styled.div`
  position:absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right:10px;
  cursor:pointer;
`
